import React from 'react';
import { Flex, Text, Button, HStack, Icon } from '@chakra-ui/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Rodape compacto: "1 a 20 de 57" e anterior/proxima.
const RodapePaginacao = ({ pagina, paginas, total, porPagina, onMudar, rotulo = 'itens' }) => {
    if (!total) return null;
    const inicio = (pagina - 1) * porPagina + 1;
    const fim = Math.min(total, pagina * porPagina);

    return (
        <Flex px={{ base: 3, md: 4 }} py={2.5} align="center" justify="space-between" gap={2} borderTopWidth="1px" borderTopColor="gray.100" flexWrap="wrap">
            <Text fontSize="xs" color="gray.500">{inicio} a {fim} de {total} {rotulo}</Text>
            {paginas > 1 && (
                <HStack spacing={1}>
                    <Button size="xs" variant="outline" leftIcon={<Icon as={FaChevronLeft} />} onClick={() => onMudar(pagina - 1)} isDisabled={pagina <= 1} aria-label="Página anterior">
                        Anterior
                    </Button>
                    <Text fontSize="xs" color="gray.600" px={2} aria-live="polite">{pagina} / {paginas}</Text>
                    <Button size="xs" variant="outline" rightIcon={<Icon as={FaChevronRight} />} onClick={() => onMudar(pagina + 1)} isDisabled={pagina >= paginas} aria-label="Próxima página">
                        Próxima
                    </Button>
                </HStack>
            )}
        </Flex>
    );
};

export default RodapePaginacao;
